import {createAction, handleActions} from 'redux-actions';
import {call, put, takeLatest} from 'redux-saga/effects';
import createRequestSaga, {createRequestActionTypes} from '../../api/createRequestSaga';
import * as feedbackAPI from '../../api/admin/feedback';
import {finishLoading, startLoading} from '../loading';

const INITIALIZE = 'adminFeedback/INITIALIZE';
const CHANGE_FIELD = 'adminFeedback/CHANGE_FIELD';
const [READ_FEEDBACK_LIST, READ_FEEDBACK_LIST_SUCCESS, READ_FEEDBACK_LIST_FAILURE] = createRequestActionTypes('adminFeedback/READ_FEEDBACK_LIST');
const [READ_FEEDBACK_DETAIL, READ_FEEDBACK_DETAIL_SUCCESS, READ_FEEDBACK_DETAIL_FAILURE] = createRequestActionTypes('adminFeedback/READ_FEEDBACK_DETAIL');
const [UPDATE_COMMENT, UPDATE_COMMENT_SUCCESS, UPDATE_COMMENT_FAILURE] = createRequestActionTypes('adminFeedback/UPDATE_COMMENT');

export const initialize = createAction(INITIALIZE);

export const changeField = createAction(
    CHANGE_FIELD,
    ({ name, value }) => ({ name, value })
);

export const readFeedbackList = createAction(
    READ_FEEDBACK_LIST,
    ({ f_type, state, s_type, start_date, end_date, employee, content, page }) => ({ f_type, state, s_type, start_date, end_date, employee, content, page })
);


export const readFeedbackListSuccess = createAction(
    READ_FEEDBACK_LIST_SUCCESS,
    ({ data, pagination }) => ({ data, pagination })
);

export const readFeedbackDetail = createAction(
    READ_FEEDBACK_DETAIL,
    ({ id }) => ({ id })
);

export const updateComment = createAction(
    UPDATE_COMMENT,
    ({ id, type, adminComment, userComment }) => ({ id, type, adminComment, userComment })
);

// const readFeedbackListSaga = createRequestSaga(READ_FEEDBACK_LIST, feedbackAPI.readFeedbackList);
function* readFeedbackListSaga(action) {
    yield put(startLoading(READ_FEEDBACK_LIST));
    try {
        const response = yield call(feedbackAPI.readFeedbackList, action.payload);
        yield put(readFeedbackListSuccess({ data: response.data.data, pagination: response.data.data.pagination }));
    } catch (e) {
        yield put({
            type: READ_FEEDBACK_LIST_FAILURE,
            payload: e,
            error: true
        })
    }
    yield put(finishLoading(READ_FEEDBACK_LIST));
}

const readFeedbackDetailSaga = createRequestSaga(READ_FEEDBACK_DETAIL, feedbackAPI.readFeedbackDetail);

const updateCommentSaga = createRequestSaga(UPDATE_COMMENT, feedbackAPI.updateComment);

export function* adminFeedbackSaga() {
    yield takeLatest(READ_FEEDBACK_LIST, readFeedbackListSaga);
    yield takeLatest(READ_FEEDBACK_DETAIL, readFeedbackDetailSaga);
    yield takeLatest(UPDATE_COMMENT, updateCommentSaga);
}

const initialState = {
    f_type: 'NEGATIVE',
    state: null,
    s_type: null,
    start_date: null,
    end_date: null,
    employee: null,
    content: null,
    page: 1,
    listResponse: null,
    listErrorResponse: null,
    detailResponse: null,
    detailErrorResponse: null,
    updateResponse: null,
    updateErrorResponse: null,
    pagination: null
};

const adminFeedback = handleActions(
    {
        [INITIALIZE]: () => initialState,
        [CHANGE_FIELD]: (state, { payload: { name, value }} ) => ({
            ...state,
            [name]: value
        }),
        [READ_FEEDBACK_LIST_SUCCESS]: (state, { payload: { data, pagination } }) => ({
            ...state,
            listResponse: data,
            listErrorResponse: null,
            pagination: pagination
        }),
        [READ_FEEDBACK_LIST_FAILURE]: (state, { payload: error }) => ({
            ...state,
            listResponse: null,
            listErrorResponse: error,
            pagination: null
        }),
        [READ_FEEDBACK_DETAIL_SUCCESS]: (state, { payload: response }) => ({
            ...state,
            detailResponse: response.data,
            detailErrorResponse: null,
            updateResponse: null,
            updateErrorResponse: null
        }),
        [READ_FEEDBACK_DETAIL_FAILURE]: (state, { payload: error }) => ({
            ...state,
            detailResponse: null,
            detailErrorResponse: error,
            updateResponse: null,
            updateErrorResponse: null
        }),
        [UPDATE_COMMENT_SUCCESS]: (state, { payload: response }) => {
            const updatedItem = response.data;

            let updatedListResponse = null;
    
            if (state.listResponse && state.listResponse.content && updatedItem && updatedItem.id) {
                updatedListResponse = {
                    ...state.listResponse,
                    content: state.listResponse.content.map(item =>
                        item.id === updatedItem.id ? { ...item, state: updatedItem.state } : item
                    )
                };
            }
    
            return {
                ...state,
                updateResponse: response.data,
                updateErrorResponse: null,
                listResponse: updatedListResponse || state.listResponse
            };
        },
        [UPDATE_COMMENT_FAILURE]: (state, { payload: error }) => ({
            ...state,
            updateResponse: null,
            updateErrorResponse: error,
        })
    },
    initialState
);

export default adminFeedback;
